import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ImageWithRegions from '../../Forms/Fields/ImageArtist/ImageWithRegions';
import styles from './index.module.scss';
import COLORS from '../../../utils/constants/colors';
import FormPopup from 'components/Operational/FormPopup';
import Evidence from '../Evidence';
import ButtonIcon from '../../IconButton';
import { ArrowRightIcon } from '../../../Icons';
import { transformEvidence } from '../../../utils/DataTransform/CleanerTask/CleanerTaskDetails';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  displayContainer: {
    background: COLORS.DARK_GREY_01,
    overflowY: 'auto',
    position: 'relative',
    height: '35rem',
    width: '40rem',
  },
}));

const ImageMarker = ({ value, imageUrl, boundryList }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showPopup, setShowPopup] = useState(false);
  const [evidence, setEvidence] = useState([]);
  const closePopup = () => {
    setShowPopup(false);
  };

  const onClick = (e, evidence) => {
    e.preventDefault();
    const formatEvidence = transformEvidence({ data: evidence });
    setEvidence(formatEvidence);
    setShowPopup(true);
  };

  const PatrolPath = () => {
    return (
      <>
        <table>
          <thead className={styles.boundaryHeader}>
            <tr>
              <th>{t('Sequence')}</th>
              <th className={styles.tMargin}>X</th>
              <th className={styles.tMargin}>Y</th>
              <th className={styles.tMargin}>{t('Evidence')}</th>
            </tr>
          </thead>
          <tbody>
            {boundryList.reduce((current, marker) => {
              if (marker.type === 'CHECKPOINT') {
                return current.concat(
                  <tr key={marker.text}>
                    <td className={styles.tMargin}>{marker.text}</td>
                    <td className={styles.tMargin}>{marker.lng}</td>
                    <td className={styles.tMargin}>{marker.lat}</td>
                    {marker.evidence ? (
                      <td className={styles.tMargin}>
                        <ButtonIcon
                          title="Evidence"
                          component={ArrowRightIcon}
                          onClick={e => onClick(e, marker.evidence)}
                          noHorizontalPadding
                        />
                      </td>
                    ) : null}
                  </tr>,
                );
              } else {
                return current;
              }
            }, [])}
          </tbody>
        </table>
        {showPopup && (
          <FormPopup
            headerTitle="Evidence"
            closePopup={closePopup}
            className={classes.displayContainer}
            form={<Evidence value={{ data: evidence }} />}
          />
        )}
      </>
    );
  };
  const ImageWithCheckpoints = () => {
    return (
      <section className={styles.imageToDisplay}>
        <ImageWithRegions
          markers={value}
          imageUrl={imageUrl}
          passPropsAndHandlers={false}
        />
      </section>
    );
  };

  return (
    <>
      {boundryList && <PatrolPath />}
      <ImageWithCheckpoints />
    </>
  );
};
export default ImageMarker;

ImageMarker.propTypes = {
  value: PropTypes.array,
  imageUrl: PropTypes.string,
  boundryList: PropTypes.array,
};
